import { Component, inject, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, RouterModule, RouterOutlet } from '@angular/router';
import { DrawerModule } from 'primeng/drawer';
import { MessageService } from 'primeng/api';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, DrawerModule, RouterModule],
  providers: [MessageService],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  visible: boolean = false;
  title = 'va-backoffice';
  breadcrumbValue = [];
  private router = inject(Router);

  constructor(private translate: TranslateService,
    private authService: AuthService,
  ) {
  }

  async ngOnInit() {
    this.authService.getUserInfo().subscribe(user => {
      const redirect = localStorage.getItem('redirectAfterLogin');

      if (user) {
        if (redirect) {
          localStorage.removeItem('redirectAfterLogin');
          this.router.navigateByUrl(redirect);
        } else if (location.pathname === '/login' || location.pathname === '/') {
          // Sei loggato e sei sulla root ti mando a /home
          this.router.navigateByUrl('/home');
        }
      }
    });
  }

  closeDrawer() {
    this.visible = false;
  }
}
